var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFruits(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147.555,
    height: 150,
    viewBox: "0 0 147.555 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fruits",
    transform: "translate(-3 -2.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M75.359,31.975c-1.428.119-2.832.19-4.141.19A50.264,50.264,0,0,1,59.937,30.9a2.38,2.38,0,0,1-1.714-1.714A42.838,42.838,0,0,0,35.9,36.52a39.816,39.816,0,0,0,5.64,8.639,45.718,45.718,0,0,1-4.76,63.639A43.243,43.243,0,1,0,75.359,31.975",
    transform: "translate(45.399 36.781)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M27.106,30.439h0a30.558,30.558,0,0,1,2.523-12.518A21.419,21.419,0,0,1,39.505,7.044a2.379,2.379,0,0,0-2.118-4.26,26.036,26.036,0,0,0-12.114,13.09A34.2,34.2,0,0,0,22.56,26.226a38.078,38.078,0,0,1,2.523,4.093,19.229,19.229,0,0,1,2.023,0",
    transform: "translate(26.991)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M78.781,66.237a37.2,37.2,0,0,1-9.734-26.631,22.61,22.61,0,0,0-.619-7.14A21.681,21.681,0,0,0,52.411,16.711a24.085,24.085,0,0,0-5.117-.571h0a40.815,40.815,0,0,1,2.38,9.163,2.38,2.38,0,0,1-1.642,2.57A53.739,53.739,0,0,1,33.42,29.9a43.29,43.29,0,0,1-6.283-.262,21.109,21.109,0,0,0-1,3,21.919,21.919,0,0,0-.619,7.14,37.293,37.293,0,0,1-9.734,26.536,41.054,41.054,0,1,0,62.949,0",
    transform: "translate(4.422 18.773)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M39.095,21.933c9.186,3.5,13.209,11.9,14.922,17.8a43.6,43.6,0,0,1,2.38-7.354,28.559,28.559,0,0,0-15.517-14.9,2.384,2.384,0,1,0-1.714,4.45",
    transform: "translate(47.797 20.405)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M68.592,28.765a2.384,2.384,0,0,1,4.046,2.523C67.712,39.261,56.764,44.449,50.767,46.8c6,.714,16.493.9,24.8-4.546C87.917,34.239,90.749,16.58,90.749,16.58c-13.328,5.759-15.4.571-29.63,5.759C50.481,26.266,47.268,38.047,46.34,43.306,50.172,42,63.571,36.881,68.592,28.718",
    transform: "translate(59.806 19.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M20.4,34.4c8.9,5.212,19.753,4.522,26.179,3.451A40.911,40.911,0,0,1,25.514,22.785a2.381,2.381,0,1,1,3.879-2.761,33.533,33.533,0,0,0,5.736,6.188l8.734,5.5a36.532,36.532,0,0,0,7.5,2.38C50.146,28.711,46.2,16.193,34.7,12.67,19.231,7.982,17.279,13.456,3,8.22c0,0,3.951,18.325,17.4,26.179",
    transform: "translate(0 7.844)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFruits);
export default __webpack_public_path__ + "static/media/Fruits.eeabba064addf948fcad69a1c4527409.svg";
export { ForwardRef as ReactComponent };